import React, { useEffect, useState, useRef } from 'react';
import { getShopLocations, createShopLocation, updateShopLocation, deleteShopLocation, reorderShopLocations } from '../services/shopLocationService';
import toast from 'react-hot-toast';

export default function AdminShopLocations() {
    const [shops, setShops] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [currentShop, setCurrentShop] = useState(null);
    const [formData, setFormData] = useState({ name: '', address: '', mapsLink: '', latitude: '', longitude: '' });
    const [submitting, setSubmitting] = useState(false);

    // Drag and drop state
    const dragItem = useRef();
    const dragOverItem = useRef();

    useEffect(() => {
        loadShops();
    }, []);

    const loadShops = async () => {
        setLoading(true);
        try {
            const data = await getShopLocations();
            setShops(data);
        } catch (err) {
            toast.error('Gabim gjatë ngarkimit të dyqaneve');
        } finally {
            setLoading(false);
        }
    };

    const handleOpenModal = (shop = null) => {
        if (shop) {
            setCurrentShop(shop);
            setFormData({
                name: shop.name,
                address: shop.address,
                mapsLink: shop.mapsLink || '',
                latitude: shop.latitude || '',
                longitude: shop.longitude || ''
            });
        } else {
            setCurrentShop(null);
            setFormData({ name: '', address: '', mapsLink: '', latitude: '', longitude: '', });
        }
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentShop(null);
        setFormData({ name: '', address: '', mapsLink: '', latitude: '', longitude: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (submitting) return;
        setSubmitting(true);
        try {
            if (currentShop) {
                await updateShopLocation(currentShop.id, formData);
                toast.success('Dyqani u përditësua me sukses');
            } else {
                await createShopLocation(formData);
                toast.success('Dyqani u shtua me sukses');
            }
            handleCloseModal();
            loadShops();
        } catch (err) {
            toast.error('Gabim gjatë ruajtjes së dyqanit');
        } finally {
            setSubmitting(false);
        }
    };

    const handleSort = async () => {
        const _shops = [...shops];
        const draggedItemContent = _shops.splice(dragItem.current, 1)[0];
        _shops.splice(dragOverItem.current, 0, draggedItemContent);

        dragItem.current = null;
        dragOverItem.current = null;

        // Optimistically update UI
        setShops(_shops);

        // Prepare payload for backend
        const orderedShops = _shops.map((shop, index) => ({
            id: shop.id,
            orderIndex: index
        }));

        try {
            await reorderShopLocations(orderedShops);
            toast.success('Renditja u ruajt!');
        } catch (err) {
            toast.error('Gabim gjatë ruajtjes së renditjes');
            loadShops(); // Revert on failure
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('A jeni të sigurt që dëshironi të fshini këtë dyqan?')) return;
        try {
            await deleteShopLocation(id);
            toast.success('Dyqani u fshi');
            loadShops();
        } catch (err) {
            toast.error('Gabim gjatë fshirjes');
        }
    };

    if (loading) return <div className="admin-text" style={{ padding: 20 }}>Duke ngarkuar...</div>;

    return (
        <div>


            <div className="admin-card">
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
                    <button className="admin-btn admin-btn-primary" onClick={() => handleOpenModal()} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>
                        Shto Dyqan
                    </button>
                </div>
                <div className="admin-table-container">
                    <table className="admin-table">
                        <thead>
                            <tr>
                                <th style={{ width: '40px' }}></th>
                                <th>Emri</th>
                                <th>Adresa</th>
                                <th>Google Maps</th>
                                <th style={{ textAlign: 'right' }}>Veprimet</th>
                            </tr>
                        </thead>
                        <tbody>
                            {shops.length === 0 ? (
                                <tr>
                                    <td colSpan="5" className="admin-text" style={{ textAlign: 'center', padding: '40px' }}>
                                        Nuk ka asnjë dyqan të regjistruar.
                                    </td>
                                </tr>
                            ) : (
                                shops.map((shop, index) => (
                                    <tr
                                        key={shop.id}
                                        draggable
                                        onDragStart={(e) => dragItem.current = index}
                                        onDragEnter={(e) => dragOverItem.current = index}
                                        onDragEnd={handleSort}
                                        onDragOver={(e) => e.preventDefault()}
                                        style={{ cursor: 'grab' }}
                                    >
                                        <td style={{ color: '#acc1e6', cursor: 'grab', textAlign: 'center' }}>
                                            ☰
                                        </td>
                                        <td style={{ fontWeight: 600 }}>{shop.name}</td>
                                        <td>{shop.address}</td>
                                        <td>
                                            {shop.mapsLink ? (
                                                <a href={shop.mapsLink} target="_blank" rel="noopener noreferrer" style={{ color: '#047ba8', textDecoration: 'underline', fontSize: '13px' }}>
                                                    Shiko në Hartë
                                                </a>
                                            ) : '—'}
                                        </td>
                                        <td style={{ textAlign: 'right' }}>
                                            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                                                <button className="admin-btn admin-btn-secondary" style={{ padding: '6px 12px', fontSize: '12px' }} onClick={() => handleOpenModal(shop)}>
                                                    Edito
                                                </button>
                                                <button className="admin-btn" style={{ padding: '6px 12px', fontSize: '12px', background: '#fee2e2', color: '#dc2626', border: 'none' }} onClick={() => handleDelete(shop.id)}>
                                                    Fshi
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {showModal && (
                <div className="admin-modal-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) handleCloseModal(); }}>
                    <div className="admin-modal-container" onClick={e => e.stopPropagation()} style={{ maxWidth: '500px' }}>
                        <div className="admin-modal-header">
                            <h2 className="admin-modal-title">{currentShop ? 'Edito Dyqanin' : 'Shto Dyqan të Ri'}</h2>
                            <button className="admin-modal-close" onClick={handleCloseModal}>✕</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="admin-modal-body">
                                <div style={{ marginBottom: '15px' }}>
                                    <label className="admin-detail-label" style={{ display: 'block', marginBottom: '5px' }}>Emri i Dyqanit</label>
                                    <input
                                        type="text"
                                        className="admin-input"
                                        value={formData.name}
                                        onChange={e => setFormData({ ...formData, name: e.target.value })}
                                        required
                                        placeholder="p.sh. Dyqani Qëndror"
                                    />
                                </div>
                                <div style={{ marginBottom: '15px' }}>
                                    <label className="admin-detail-label" style={{ display: 'block', marginBottom: '5px' }}>Adresa</label>
                                    <input
                                        type="text"
                                        className="admin-input"
                                        value={formData.address}
                                        onChange={e => setFormData({ ...formData, address: e.target.value })}
                                        required
                                        placeholder="p.sh. Rruga e Kavajës, Tiranë"
                                    />
                                </div>
                                <div style={{ marginBottom: '15px' }}>
                                    <label className="admin-detail-label" style={{ display: 'block', marginBottom: '5px' }}>Linku i Google Maps</label>
                                    <textarea
                                        className="admin-input"
                                        style={{ minHeight: '80px', resize: 'vertical' }}
                                        value={formData.mapsLink}
                                        onChange={e => setFormData({ ...formData, mapsLink: e.target.value })}
                                        placeholder="Ngjitni linkun e lokacionit nga Google Maps këtu..."
                                    />
                                </div>

                                <div style={{ display: 'flex', gap: '15px', marginBottom: '15px' }}>
                                    <div style={{ flex: 1 }}>
                                        <label className="admin-detail-label" style={{ display: 'block', marginBottom: '5px' }}>Gjerësia (Latitude)</label>
                                        <input
                                            type="text"
                                            className="admin-input"
                                            value={formData.latitude}
                                            onChange={e => setFormData({ ...formData, latitude: e.target.value })}
                                            placeholder="p.sh. 41.3275"
                                        />
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <label className="admin-detail-label" style={{ display: 'block', marginBottom: '5px' }}>Gjatësia (Longitude)</label>
                                        <input
                                            type="text"
                                            className="admin-input"
                                            value={formData.longitude}
                                            onChange={e => setFormData({ ...formData, longitude: e.target.value })}
                                            placeholder="p.sh. 19.8187"
                                        />
                                    </div>
                                </div>

                                <div style={{
                                    padding: '12px',
                                    background: '#f0f9ff',
                                    borderRadius: '8px',
                                    border: '1px solid #bae6fd',
                                    fontSize: '13px',
                                    color: '#0369a1',
                                    marginBottom: '15px'
                                }}>
                                    <strong style={{ display: 'block', marginBottom: '4px' }}>💡 Si të gjeni koordinatat:</strong>
                                    Hapni Google Maps, klikoni me të djathtën mbi lokacionin dhe klikoni mbi numrat (p.sh. 41.32, 19.81) për t'i kopjuar ato.
                                </div>
                            </div>
                            <div className="admin-modal-footer">
                                <button type="button" className="admin-btn admin-btn-secondary" onClick={handleCloseModal} disabled={submitting}>Anulo</button>
                                <button type="submit" className="admin-btn admin-btn-primary" disabled={submitting}>
                                    {submitting ? 'Duke ruajtur...' : (currentShop ? 'Përditëso' : 'Ruaj')}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
